module.exports = __webpack_public_path__ + "arr_r.5c1c769d.png";